export default __webpack_public_path__ + "static/a-webbased-printing-platform-for-enterprises-5dbd9ff020f1579242a9cc319eec55a4.png";